<template>
    <ul v-if="products"
        @scroll="$emit('scroll', $event)">
        <template
            v-for="index in limit">
            <ProductListItem
                v-if="index <= products.length"
                class="text-center"
                :key="products[index - 1].id"
                :product="products[index - 1]"
                :options="itemOptions"/>
            <div v-else class="aspect aspect-shirt frame-background rounded"/>
        </template>
    </ul>
</template>

<script>
    import {lazyLoadInstance, appendQueryString} from "../../../common/common";
    import ProductCatalogPrice from "./ProductCatalogPrice";
    import ProductListItem from "./ProductListItem";

    export default {
        name: "ProductGroupList",

        components: {ProductListItem, ProductCatalogPrice},

        props: {
            id: Number,
            limit: {
                type: Number,
                default: 8
            },
            displayName: {
                type: Boolean,
                default: true
            },
            showPrice: Boolean,
            showInstallments: Boolean,
            showOnlyThumb: Boolean,
            products: Array
        },

        mounted() {
            lazyLoadInstance.update();
        },

        computed: {
            itemOptions() {
                return {
                    displayName: true,
                    displayPrice: this.showPrice,
                    hideInstallments: !this.showInstallments,
                    displayArt: true,
                    imageWidth: 300
                }
            }
        },

        methods: {
            getName(art) {
                return art.name.replace('Camiseta ', '');
            },

            getImageLink(url) {
                return appendQueryString(url, {
                    'auto': 'format',
                    'lossless': 1,
                    'w': 500
                });
            }
        }
    }
</script>